import { CorporateCard } from './types';

export const formatCard = (card: Pick<CorporateCard, 'brand' | 'bank' | 'last4' | 'holder'>): string =>
	`${card.brand} ${card.bank} •••• ${card.last4} — ${card.holder}`;

export const formatCardShort = (card: Pick<CorporateCard, 'brand' | 'last4'>): string =>
	`${card.brand} ••••${card.last4}`;
